import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-sas-clinic-forgot-password',
  templateUrl: './sas-clinic-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './sas-clinic-forgot-password.component.css',
  ],
})
export class SasClinicForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
